module.exports = __webpack_public_path__ + "img/saint_germain.67711dd9.jpeg";